/*
 * @Description:
 * @Author: zhanjunwei
 * @Date: 2024-12-10 16:18:34
 * @LastEditors: zhanjunwei
 * @LastEditTime: 2025-01-16 10:32:17
 */
import { FormRule } from 'tdesign-react';
export const ruleRequired = ({
  text,
  content,
}: {
  [string: string]: string | undefined;
}) => {
  const value: FormRule = {
    required: true,
    message: content ?? '请输入' + text,
    type: 'error',
  };
  return value;
};

export const ruleEmail: FormRule = {
  email: { ignore_max_length: true },
  message: '请输入正确的邮箱地址',
  type: 'error',
};

export const rulePhone: FormRule = {
  telnumber: true,
  message: '请输入正确的手机号码',
  type: 'error',
};
export const ruleIdcard: FormRule = {
  idcard: true,
  message: '请输入正确的身份证号',
  type: 'error',
};

/** 不允许输入中文字符 */
export const ruleNoChinese: FormRule = {
  validator: (val) => {
    if (!val) return true;
    return !/[一-龥]/.test(String(val));
  },
  message: '不支持输入中文字符',
};

/** 仅允许输入英文字母和空格 */
export const ruleEnglishOnly: FormRule = {
  validator: (val) => {
    if (!val) return true;
    return /^[a-zA-Z\s]+$/.test(String(val));
  },
  message: '仅支持输入英文字符和空格',
};

/** 仅允许输入中文、英文字母、空格和间隔号(·) */
export const ruleChineseEnglishOnly: FormRule = {
  validator: (val) => {
    if (!val) return true;
    return /^[a-zA-Z一-龥\s·]+$/.test(String(val));
  },
  message: '仅支持输入中英文、空格和间隔号(·)',
};

export const ruleLength = (number: number): FormRule => ({
  // 与后端 Go rune 口径对齐，混合中英文或带重音字符不会因 UTF-16 码元数被误判。
  validator: (val) => (val ? Array.from(String(val)).length <= number : true),
  message: `内容文本长度不能超过 ${number} 个字`,
});

const dateRegex = /^\d{4}年(0?[1-9]|1[0-2])月(0?[1-9]|[12]\d|3[01])日$/;

const isValidDate = (value: string): boolean => {
  const match = value.match(
    /^(\d{4})年(0?[1-9]|1[0-2])月(0?[1-9]|[12]\d|3[01])日$/
  );
  if (!match) return false;

  const year = parseInt(match[1], 10);
  const month = parseInt(match[2], 10);
  const day = parseInt(match[3], 10);

  const daysInMonth = [
    31,
    isLeapYear(year) ? 29 : 28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31,
  ];

  return day > 0 && day <= daysInMonth[month - 1];
};

const isLeapYear = (year: number): boolean => {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
};

export const ruleDate = {
  validator: (value: string) => {
    if (value === '长期') {
      return true;
    }

    if (!dateRegex.test(value)) {
      return false;
    }

    if (!isValidDate(value)) {
      return false;
    }

    return true;
  },
  message: '请输入正确的日期',
};
